import { ExerciseAbcBase } from './exerciseAbcBase';

export class ExerciseAbc3 extends ExerciseAbcBase {
  constructor() {
    super('ExerciseAbc3', 3);
  }
}
